<template>
  <v-card class="ma-4">
    <v-toolbar>
      <v-toolbar-title>SERVE Supervisor Portal</v-toolbar-title>
      <v-spacer />
      <v-select v-model="area" :items="areas" label="Area" outlined hide-details dense class="mt-1 ml-2" style="max-width:200px" />
      <v-select v-model="term" :items="terms" label="Term" outlined hide-details dense class="mt-1 ml-2" style="max-width:200px" />
    </v-toolbar>
    <v-tabs v-if="area === 'Events'" v-model="tab">
      <v-tab>Students</v-tab>
      <v-tab>Events</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-toolbar>
          <v-text-field v-model="search" label="Table Filter" dense outlined hide-details class="mr-2" style="max-width:200px" />
          <v-select v-model="statusFilter" :items="statusOptions" label="Status Filter" dense outlined hide-details class="mr-2" style="max-width:200px" />
          <v-btn v-if="area === 'Events'" @click="addToEventActive = !addToEventActive">{{ addToEventActive ? 'Hide' : 'Show' }}: Add Students To Event</v-btn>
          <v-btn v-else @click="addHoursActive = !addHoursActive">{{ addHoursActive ? 'Hide' : 'Show' }}: Add Hours</v-btn>
          <v-dialog v-model="helpDialog" width="400">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon color="info">fas fa-question-circle</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title v-if="area === 'Events'">Adding Students to Events</v-card-title>
              <v-card-title v-else>Adding Hours to Students</v-card-title>
              <v-card-text>
                <p v-if="area === 'Events'">To add students to an event, you must first create an event (using the Events tab). Once the event has been created, click the "Show: Add Students to Event" button. This will reveal a second toolbar where you can choose the event, set the hours, and the default status for the students who will be connected to that event. Then check which students to add to the event to using the revealed checkboxes in the first column of the table. You can use the table filter on the first toolbar to search the table for the students you want to add. Once all of the students are checked, click the Add To Event button to add them to the event. If you chose the "Completed" status then the Completed Hours columns should update with their completed hours. If you chose the "Committed" status, then the Committed Hours column should update with their committed hours.</p>
                <p v-else>To add hours to students, click the "Show: Add Hours" button. This will reveal a second toolbar for adding the hours. On that toolbar, enter a description, the date the student(s) served, and select the number of hours. Then check which students to add the hours to using the revealed checkboxes in the first column of the table. You can use the table filter on the first toolbar to search the table for the students you want to add. Once all of the students are checked, click the Add Hours button to add the hours.</p>
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="helpDialog = false">Got it</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <!-- <v-toolbar v-if="addToEventActive && area === 'Events'">
          <v-select v-model="eventAddEvent" :items="eventList" item-text="name" item-value="_id" dense outlined hide-details class="mr-2" style="max-width:300px" @change="selectEvent">
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ stringFormatDate(item.date) }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-select>
          <v-select v-model="eventAddStatus" :items="eventStatusOptions" label="Status" dense outlined hide-details class="mr-2" style="max-width:200px" />
          <v-autocomplete v-model="eventAddHours" :items="hourOptions" label="Hours" dense outlined hide-details class="mr-2" style="max-width:100px" />
          <v-btn v-if="addIsRunning" disabled>Adding students to event...</v-btn>
          <v-btn v-else :disabled="addSelected.length === 0 || eventAddEvent === '' || eventAddStatus === '' || eventAddHours === 0" @click="addStudentsToEvent()">Add Students To Event</v-btn>
        </v-toolbar> -->
        <v-toolbar v-if="addHoursActive && area !== 'Events'">
          <v-text-field v-model="add.desc" label="Description" outlined dense hide-details class="mr-2" style="max-width:300px" />
          <date-picker v-model="add.date" label="Date Served" outlined dense hide-details input-class="mr-2" max-width="150px" style="max-width:300px" />
          <v-autocomplete v-model="add.hours" :items="hourOptions" label="Hours" dense outlined hide-details class="mr-2" style="max-width:100px" />
          <v-btn :disabled="add.desc === '' || add.hours == null || addSelected.length === 0 || add.date === ''" color="success" @click="addHours">
            <v-icon left small>fas fa-plus-circle</v-icon>
            Add Hours
          </v-btn>
        </v-toolbar>
        <v-data-table v-model="addSelected" :items="students" :headers="headers" :show-select="addHoursActive || addToEventActive" :search="search" :group-by="area === 'Events' ? 'area' : null">
          <template v-slot:header.data-table-select>
            <v-icon v-if="addSelected.length === students.length" color="info" @click="addSelected=[]">fas fa-check-square</v-icon>
            <v-icon v-else-if="addSelected.length > 0" @click="selectAll()">fas fa-minus-square</v-icon>
            <v-icon v-else @click="selectAll()">far fa-square</v-icon>
            <!-- <v-checkbox :value="addSelected.length === students.length" :indeterminate="addSelected.length > 0 && addSelected.length < students.length" @click="toggleSelectAll" /> -->
          </template>
          <template v-slot:group.header="{ group, isOpen, toggle }">
            <td :colspan="headers.length" class="pa-0">
              <v-toolbar :color="darkMode ? '#333' : '#EEE'" dense style="width:100%">
                <v-btn icon @click="toggle()">
                  <v-icon>fal fa-{{ isOpen ? 'minus' : 'plus' }}</v-icon>
                </v-btn>
                <v-toolbar-title>{{ group }}</v-toolbar-title>
              </v-toolbar>
            </td>
          </template>
          <template v-slot:item.data-table-select="{ item }">
            <v-tooltip v-if="alreadySelected.includes(item.pidm)" top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="gray">fas fa-check-square</v-icon>
              </template>
              <span>Already attached to event. To manage, go to the Events tab.</span>
            </v-tooltip>
            <v-icon v-else-if="addSelected.includes(item._id)" color="info" @click="toggleSelectOne(item._id)">fas fa-check-square</v-icon>
            <v-icon v-else @click="toggleSelectOne(item._id)">far fa-square</v-icon>
          </template>
          <template v-slot:item.lastEntry="{ item }">
            <span v-if="item.lastEntry">{{ stringFormatDate(item.lastEntry, true, true) }}</span>
          </template>
          <template v-slot:item.hours="{ item }">
            <v-chip label outlined @click="openDetail(item)">{{ item.hours || 0 }}</v-chip>
          </template>
          <template v-slot:item.committed="{ item }">
            <v-chip label outlined @click="openDetail(item)">{{ item.committed || 0 }}</v-chip>
          </template>
          <template v-slot:item.notes="{ item }">
            <v-chip v-if="item.notes" v-html="item.notes.replaceAll('\n', '<br/>')" label outlined x-small class="mr-1" style="max-width:350px;white-space: normal;height:auto;" @click="openNotesDialog(item)" />
            <v-btn x-small icon @click="openNotesDialog(item)">
              <v-icon>fas fa-{{ item.notes ? 'pencil' : 'plus-circle' }}</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.email="{ item }">
            <a @click="emailStudent(item)">{{ item.email }}</a>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-toolbar>
          <v-dialog v-model="eventDialog" width="800">
            <template #activator="{ on }">
              <v-btn v-on="on" color="success" outlined>
                <v-icon left>fas fa-plus-circle</v-icon>
                Add Event
              </v-btn>
            </template>
            <v-card>
              <v-card-title>Add Event</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-text-field v-model="newEventName" label="Event Name" outlined />
                  </v-col>
                  <v-col>
                    <date-picker v-model="newEventDate" label="Event Date" outlined />
                  </v-col>
                </v-row>
                <p>This will create the initial event record. You will then be redirected to the detail page for this event to add the additional information.</p>
              </v-card-text>
              <v-card-actions>
                <v-btn :disabled="newEventName === '' || newEventDate === ''" color="success" text @click="saveEvent">
                  <v-icon left small>fas fa-plus-circle</v-icon>
                  Add Event
                </v-btn>
                <v-spacer />
                <v-btn text @click="eventDialog = false">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-select v-model="eventFilter" :items="eventFilterOptions" label="Filter Events" outlined hide-details dense class="ml-4" style="max-width:200px" />
          <v-dialog v-model="activeEventDialog" width="400">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon color="info">
                <v-icon>fas fa-question-circle</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>Active Events</v-card-title>
              <v-card-text>An active event is one which has not yet happened, or which has at least one committed student. Once the event has passed and all students have been updated to no longer show as committed, then the event is considered finished and no longer active. You can still see the event by choosing an "All" option (Either "All My Events" or "All Events").</v-card-text>
              <v-card-actions>
                <v-btn @click="activeEventDialog = false">Got it</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-card-text>
          <v-data-table :items="eventList" :headers="eventHeaders" @dblclick:row="rowClick">
            <template v-slot:item.committedCount="{ item }">{{ item.students.filter(({ status }) => status === 'Committed').length }}</template>
            <template v-slot:item.actions="{ item }">
              <v-btn v-if="item.user === user.username || isAdmin" icon :to="`/serve/super/${item._id}`">
                <v-icon>fal fa-eye</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-model="detailDialog" width="800">
      <serve-detail :bannerId="detailId" is-dialog @updated="loadStudents()">
        <v-card-actions>
          <v-btn text @click="detailDialog = false">Close</v-btn>
        </v-card-actions>
      </serve-detail>
    </v-dialog>
    <v-dialog v-model="notesDialog" width="500">
      <v-card>
        <v-card-title>Notes for {{ notesName }}</v-card-title>
        <v-card-text>
          <v-textarea v-model="editNote" label="Note" outlined hide-details />
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" text @click="saveNote()">Save</v-btn>
          <v-spacer />
          <v-btn text @click="notesDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eventDetailDialog" width="800">
      <event-detail :event-id="selectedEventId" :all-students="students" @updated="loadEvents(); loadStudents()" />
    </v-dialog>
    <email-dialog ref="emailDialog" :data="emailData" :merge-fields="[{ label: 'Completed Hours', value: 'hours' }, { label: 'Remaining Hours', value: 'remaining' }]" />
  </v-card>
</template>
<script>
import { ref, computed, onMounted, watch } from '@vue/composition-api'
import { stringFormatDate } from '@/helpers/formatters'
export default {
  components: {
    DatePicker: () => import('@/components/forms/inputs/DatePicker'),
    ServeDetail: () => import('@/components/serve/detail'),
    EventDetail: () => import('@/components/serve/eventDetail'),
    EmailDialog: () => import('@/components/system/emailDialog')
  },
  setup (props, { root }) {
    const user = computed(() => root.$store.state.user.spoof || root.$store.state.user)
    const darkMode = computed(() => { return root.$store.state.settings.darkMode || false })
    const isAdmin = computed(() => user.value.roles.includes('Technology Services') || user.value.roles.includes('Student Development'))
    const stuServ = root.$feathers.service('serve/student')
    const areaServ = root.$feathers.service('serve/area')
    const term = ref('')
    const terms = ref([])
    const areas = ref([])
    const area = ref('')
    const tab = ref(0)
    const search = ref('')
    const students = ref([])
    const headers = computed(() => {
      const arr = [
        { text: 'Banner ID', value: 'bannerId' },
        { text: 'Last Name', value: 'last' },
        { text: 'First Name', value: 'first' },
        { text: 'Email', value: 'email' },
        { text: 'Notes', value: 'notes' },
        { text: 'Completed Hours', value: 'hours' },
        { text: 'Target Hours', value: 'target' },
        { text: 'Last Entry', value: 'lastEntry' }
      ]
      if (area.value === 'Events') {
        arr.splice(6, 0, { text: 'Committed Hours', value: 'committed' })
        arr.splice(0, 0, { text: 'Group', value: 'area' })
      }
      return arr
    })
    const statusFilter = ref('')
    const statusOptions = ref(['Incomplete', 'Completed'])
    const filteredStudents = computed(() => students.value.filter(({ })))
    const isLoaded = ref(false)

    watch(area, () => {
      if (area.value === 'Events') {
        root.$nextTick(() => {
          tab.value = 1
          console.log('Changed tab to 1')
        })
      }
    })
    watch(tab, () => {
      console.log(`Tab: ${tab.value}`)
    })

    onMounted(async () => {
      const dt = new Date()
      dt.setMonth(dt.getMonth() + 2)
      root.$feathers.service('system/term').find({ query: { term: { $gte: '202360', $regex: '(05|60)$' }, start: { $lte: dt }, $select: ['term', 'label'], $sort: { start: -1 } } }).then(({ data }) => {
        terms.value = data.map(({ term, label }) => { return { text: label, value: term } })
        term.value = data[0].term
      })

      // Make sure the current user either is an admin or has permission to one of the areas
      if (isAdmin.value) {
        const { data } = await areaServ.find({ query: { $limit: 50, $sort: { category: 1, area: 1 } } })
        areas.value = data.map(({ area }) => area)
        area.value = 'Events'
        tab.value = 1
      } else {
        const { data } = await areaServ.find({ query: { 'supervisors.email': user.value.email } })
        if (data.length === 0) {
          root.$store.dispatch('main/snackbar', { color: 'error', text: 'You are not set up with permission to enter any hours for SERVE' })
          root.$router.push('/')
        } else {
          areas.value = data.map(({ area }) => area)
          area.value = areas.value[0]
        }
      }
      isLoaded.value = true
    })

    const helpDialog = ref(false)

    async function loadStudents () {
      if (isLoaded.value && area.value !== '') {
        const aggregate = [
          { $match: { 'term': term.value, assignment: area.value, active: true } },
          { $project: { _id: 1, pidm: 1, bannerId: 1, first: 1, last: 1, startTerm: 1, notes: 1, hours: 1, target: 1, email: 1, lastEntry: { $reduce: { input: '$history', initialValue: {}, in: { $cond: { if: { $gt: ['$$this.date', '$$value.date'] }, then: '$$this', else: '$$value' } } } } } },
          { $addFields: { lastEntry: '$lastEntry.date' } },
          { $sort: { last: 1, first: 1 } }
        ]
        if (area.value === 'Events') {
          aggregate[0].$match.assignment = { $nin: ['Facilities', 'Grounds', 'Dining', 'Chapel', 'Off-Campus', '', null] }
          aggregate[1].$project.area = { $first: '$area' }
          aggregate[1].$project.committed = { $filter: { input: '$history', as: 'item', cond: { $eq: ['$$item.status', 'Committed'] } } }
          aggregate[2].$addFields.committed = { $sum: '$committed.hours' }
          aggregate[2].$addFields.category = '$area.category'
          aggregate[2].$addFields.area = '$area.area'
          aggregate[3].$sort = { last: 1, first: 1 }
          aggregate.splice(1, 0, { $lookup: { from: 'Serve-Areas', localField: 'assignment', foreignField: 'area', as: 'area' } })
          aggregate.push({ $addFields: { area: { $cond: { if: { $eq: ['$category', 'Main'] }, then: ' Events', else: { $concat: ['$category', ': ', '$area'] } } } } })
        }
        const { data } = await stuServ.find({ query: { aggregate } })
        students.value = data.map((rec) => {
          if (!('hours' in rec)) {
            rec.hours = 0
          }
          return rec
        })
      }
    }
    watch(term, () => loadStudents())
    const hourOptions = ref([0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10])
    const addHoursActive = ref(false)
    const addSelected = ref([])
    const alreadySelected = ref([])
    const add = ref({
      hours: 0,
      date: new Date().toISOString().substring(0, 10),
      desc: ''
    })
    function selectAll () {
      addSelected.value = students.value.map(({ _id }) => _id)
      setTimeout(() => { addSelected.value = students.value.map(({ _id }) => _id) }, 10)
    }
    function toggleSelectOne (_id) {
      const index = addSelected.value.findIndex((id) => id === _id)
      if (index < 0) addSelected.value.push(_id)
      else addSelected.value.splice(index, 1)
    }
    async function addHours () {
      const historyRec = { ...add.value, addedBy: user.value.username }
      const dt = new Date(add.value.date)
      dt.setHours(dt.getHours() + 8)
      historyRec.date = dt.toISOString()
      let error = false
      for (const _id of addSelected.value) {
        try {
          const data = await stuServ.patch(_id, { $push: { 'history': historyRec }, $inc: { hours: add.value.hours } })
          const index = students.value.findIndex(({ _id: id }) => id === _id)
          if (index >= 0) {
            students.value.splice(index, 1, data)
          }
        } catch (e) {
          root.$store.dispatch('main/snackbar', { color: 'error', text: 'Error updating hours: ' + e })
          error = true
        }
      }
      if (!error) {
        root.$store.dispatch('main/snackbar', { color: 'success', text: 'Hours added successfully' })
        addHoursActive.value = false
        add.value = { hours: 0, date: new Date().toISOString().substring(0, 10), desc: '' }
        addSelected.value = []
      }
    }

    const eventDialog = ref(false)
    const eventStatusOptions = ref(['Committed', 'No Show', 'Completed'])
    const newEventName = ref('')
    const newEventDate = ref('')
    async function saveEvent () {
      try {
        const data = await root.$feathers.service('serve/event').create({ name: newEventName.value, date: newEventDate.value, term: term.value })
        root.$router.push(`/serve/super/${data._id}`)
      } catch (e) {
        root.$store.dispatch('main/snackbar', { color: 'error', text: 'Error adding event: ' + e })
      }
    }
    const eventList = ref([])
    const eventFilter = ref('active-my')
    const eventHeaders = computed(() => {
      const arr = [
        { text: 'Event Name', value: 'name' },
        { text: 'Date', value: 'date' },
        { text: 'Sign-up Open', value: 'regOpen' },
        { text: 'Sign-up Closed', value: 'regClosed' },
        { text: 'Slots Available', value: 'slotCount' },
        { text: 'Slots Filled', value: 'slotsFilled' },
        { text: 'Students Committed', value: 'committed' },
        { text: 'Actions', value: 'actions' }
      ]
      if (eventFilter.value.split('-')[1] !== 'my') arr.splice(0, 0, { text: 'Created By', value: 'user' })
      return arr
    })
    const eventFilterOptions = ref([{ text: 'My Active Events', value: 'active-my' }, { text: 'All My Events', value: 'all-my' }, { text: 'All Active Events', value: 'active-all' }, { text: 'All Events', value: 'all-all' }])
    const activeEventDialog = ref(false)
    async function loadEvents () {
      const aggregate = [
        { $match: { term: term.value, active: true } },
        { $addFields: {
          committed: {
            $size: {
              $filter: {
                input: '$students',
                as: 'stu',
                cond: { $eq: ['$$stu.status', 'Committed'] }
              }
            }
          }
        } },
        { $unwind: {
          path: '$blocks',
          preserveNullAndEmptyArrays: true
        } },
        { $addFields: {
          'blocks.slotsFilled': {
            $size: {
              $filter: {
                input: '$students',
                as: 'stu',
                cond: { $in: [ { $toString: '$blocks._id' }, '$$stu.blocks.blockId' ] }
              }
            }
          }
        } },
        { $group: {
          _id: {
            _id: '$_id',
            name: '$name',
            date: '$date',
            term: '$term',
            description: '$description',
            regOpen: '$regOpen',
            regClosed: '$regClosed',
            user: '$user',
            committed: '$committed'
          },
          blocks: { $push: '$blocks' }
        } },
        { $project: {
          _id: '$_id._id',
          name: '$_id.name',
          date: '$_id.date',
          description: '$_id.description',
          regOpen: '$_id.regOpen',
          regClosed: '$_id.regClosed',
          user: '$_id.user',
          committed: '$_id.committed',
          slotCount: {
            $reduce: {
              input: '$blocks',
              initialValue: 0,
              in: { $add: ['$$value', '$$this.slotCount'] }
            }
          },
          slotsFilled: {
            $reduce: {
              input: '$blocks',
              initialValue: 0,
              in: { $add: [ '$$value', '$$this.slotsFilled' ] }
            }
          },
          blocks: 1
        } }
      ]
      const temp = eventFilter.value.split('-')
      if (temp[0] === 'active') {
        aggregate.push({ $match: { $or: [{ committed: { $gt: 0 } }, { date: { $gte: new Date() } }] } })
      }
      if (temp[1] === 'my') {
        aggregate.push({ $match: { user: user.value.username } })
      }
      aggregate.push({ $sort: { date: 1, name: 1 } })
      const { data } = await root.$feathers.service('serve/event').find({ query: { aggregate } })
      eventList.value = data
    }
    watch(eventFilter, () => {
      loadEvents()
    })

    const detailId = ref('')
    const detailDialog = ref(false)
    function openDetail ({ bannerId }) {
      detailId.value = bannerId
      detailDialog.value = true
    }

    const notesDialog = ref(false)
    const notesId = ref('')
    const notesName = ref('')
    const editNote = ref('')
    function openNotesDialog (item) {
      notesId.value = item._id
      notesName.value = item.first + ' ' + item.last
      editNote.value = item.notes
      notesDialog.value = true
    }

    async function saveNote () {
      const data = await stuServ.patch(notesId.value, { notes: editNote.value })
      const index = students.value.findIndex(({ _id }) => _id === data._id)
      students.value.splice(index, 1, data)
      notesDialog.value = false
    }

    const addToEventActive = ref(false)
    const eventAddEvent = ref('')
    const eventAddStatus = ref('')
    const eventAddHours = ref(0)
    function selectEvent (id) {
      const rec = eventList.value.find(({ _id }) => _id === id)
      console.log(rec)
      if (rec && 'students' in rec && Array.isArray(rec.students) && rec.students.length > 0) {
        alreadySelected.value = rec.students.map(({ pidm }) => pidm)
      } else {
        alreadySelected.value = []
      }
    }
    const addIsRunning = ref(false)
    async function addStudentsToEvent () {
      addIsRunning.value = true
      // Add the students to the event
      try {
        // Add the event to each student's history record
        const rec = eventList.value.find(({ _id }) => _id === eventAddEvent.value)
        const history = {
          date: rec.date,
          hours: eventAddHours.value,
          desc: rec.name,
          addedBy: user.value.username,
          event: eventAddEvent.value,
          status: eventAddStatus.value
        }
        for (const _id of addSelected.value) {
          const patch = { $push: { history } }
          // If we're adding this with a status of Completed, then add it to the hours
          if (eventAddStatus.value === 'Completed') patch.$inc = { hours: eventAddHours.value }
          await root.$feathers.service('serve/student').patch(_id, patch)
        }
        // Build our list of students to add to the event
        const list = students.value.filter(({ _id }) => addSelected.value.includes(_id)).map(({ pidm, first, last }) => { return { pidm, first, last, status: eventAddStatus.value, hours: eventAddHours.value } })
        await root.$feathers.service('serve/event').patch(eventAddEvent.value, { $push: { students: list } })
        root.$store.dispatch('main/snackbar', { color: 'success', text: 'Students added to event successfully' })
        loadStudents()
        addSelected.value = []
        eventAddEvent.value = ''
        eventAddStatus.value = ''
        eventAddHours.value = 0
      } catch (e) {
        root.$store.dispatch('main/snackbar', { color: 'error', text: 'Error adding students to event: ' + e })
      } finally {
        addIsRunning.value = false
      }
    }

    watch(area, () => {
      tab.value = 0
      loadStudents()
      if (area.value === 'Events') loadEvents()
      addHoursActive.value = false
      addToEventActive.value = false
    })

    const eventDetailDialog = ref(false)
    const selectedEventId = ref('')
    function viewEventDetail ({ _id }) {
      selectedEventId.value = _id
      eventDetailDialog.value = true
    }

    const emailDialog = ref(null)
    const emailData = ref([])
    function emailStudent (row) {
      emailData.value = [row]
      emailDialog.value.active = true
    }

    function rowClick (e, { item }) {
      root.$router.push('/serve/super/' + item._id)
    }

    return {
      user,
      darkMode,
      isAdmin,
      term,
      terms,
      areas,
      area,
      search,
      students,
      headers,
      statusFilter,
      statusOptions,
      filteredStudents,
      tab,
      helpDialog,
      loadStudents,
      hourOptions,
      addHoursActive,
      addSelected,
      alreadySelected,
      add,
      selectAll,
      toggleSelectOne,
      addHours,
      eventDialog,
      eventStatusOptions,
      newEventName,
      newEventDate,
      saveEvent,
      eventList,
      eventHeaders,
      eventFilter,
      eventFilterOptions,
      activeEventDialog,
      loadEvents,
      detailId,
      detailDialog,
      openDetail,
      notesDialog,
      notesId,
      notesName,
      editNote,
      openNotesDialog,
      saveNote,
      addToEventActive,
      eventAddEvent,
      eventAddStatus,
      eventAddHours,
      selectEvent,
      addIsRunning,
      addStudentsToEvent,
      eventDetailDialog,
      selectedEventId,
      viewEventDetail,
      emailDialog,
      emailData,
      emailStudent,
      rowClick,
      stringFormatDate
    }
  }
}
</script>
